import { module } from "angular";
import { IconComponent } from "./IconComponent";

module("mmGui").component("irIcon", new IconComponent());
